export default __webpack_public_path__ + "static/media/Man Basket.294cc05d.jpg";